import { render, staticRenderFns } from "./CommonCheckoutContact.vue?vue&type=template&id=edc20c96&scoped=true"
import script from "./CommonCheckoutContact.vue?vue&type=script&lang=js"
export * from "./CommonCheckoutContact.vue?vue&type=script&lang=js"
import style0 from "./CommonCheckoutContact.vue?vue&type=style&index=0&id=edc20c96&prod&lang=scss"
import style1 from "./CommonCheckoutContact.vue?vue&type=style&index=1&id=edc20c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc20c96",
  null
  
)

export default component.exports